import { formatSalesOrderNumber } from '@order-management/format';
import { EditDeviceGroupsTableRow } from '@order-management/types';
import { useMemo } from 'react';
import { Element } from 'react-bulma-components';
import { formatDateToLocaleString } from '../../../shared/utils';
import Link from '../../../ui/link/link';
import PaginatedTable, {
  CustomPaginatedTableProps,
} from '../../../ui/table/paginated-table/paginated-table';
import { Column } from '../../../ui/table/types';

export type EditDeviceGroupsTableProps =
  CustomPaginatedTableProps<EditDeviceGroupsTableRow>;

export function EditDeviceGroupsTable({
  dataSource,
  onChange,
  config,
  form,
}: EditDeviceGroupsTableProps) {
  const columns: Column<EditDeviceGroupsTableRow>[] = [
    {
      key: 'number',
      className: 'is-width-20',
      render: (el) => (
        <Link to={`/sales-orders/${el.order.id}`}>
          {formatSalesOrderNumber(el.order.number)}
        </Link>
      ),
      title: 'Sales order',
      sortable: true,
    },
    {
      key: 'model_name',
      className: 'is-width-30',
      render: (el) => <p>{el.deviceModel.name}</p>,
      title: 'Device Type',
      sortable: true,
    },
    {
      key: 'purchase',
      className: 'is-width-10',
      render: (el) => formatDateToLocaleString(el.purchaseDate),
      title: 'Purchase date',
      sortable: true,
    },
    {
      key: 'close',
      className: 'is-width-10',
      render: (el) =>
        el.closeDate ? formatDateToLocaleString(el.closeDate) : '',
      title: 'Close date',
      sortable: true,
    },
    {
      key: 'total',
      className: 'is-width-10',
      render: (el) => el.totalDevices,
      title: 'Total',
      sortable: true,
    },
    {
      key: 'available',
      className: 'is-width-10',
      render: (el) => el.totalAvailable,
      title: 'Available',
      sortable: true,
    },
    {
      key: 'devices',
      className: 'is-width-10',
      render: (el) => el.deviceGroupAssignedDevices,
      title: 'Devices',
      sortable: false,
    },
  ];

  const emptyContentText = useMemo(() => {
    const hasAppliedFilters = config.search !== '';
    if (hasAppliedFilters) {
      return 'There are no devices that match the selected criteria';
    }

    return 'There are no devices at the moment';
  }, [config.search]);

  return (
    <PaginatedTable
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      config={config}
      form={form}
      rowKey={'id'}
      empty={
        <Element display="flex" justifyContent="center" className="my-2">
          <span className="has-text-weight-light">{emptyContentText}</span>
        </Element>
      }
    />
  );
}

export default EditDeviceGroupsTable;
